import { Company } from '@/api';
import { ReactElement, ReactNode, useMemo } from 'react';
import { CompaniesContext, CompaniesContextData } from './context';

type CompaniesProviderProps = {
    readonly companies: Company[];
    readonly children?: ReactNode;
};

export function CompaniesProvider({
    companies,
    children
}: CompaniesProviderProps): ReactElement {
    const companiesMap = useMemo(() => {
        const map = new Map<string, Company>();
        companies.forEach((company) => {
            map.set(company.id, company);
        });
        return map;
    }, [companies]);

    const value: CompaniesContextData = {
        companies,
        companiesMap
    };

    return (
        <CompaniesContext.Provider value={value}>
            {children}
        </CompaniesContext.Provider>
    );
}
